export default __webpack_public_path__ + "static/media/Rangarajan_Krishnan.18a09d55.png";